import Instance from "./request";
const baseURL = process.env.VUE_APP_API_URL;
import { trimString } from "../utils/common";

export default {
  // 获取图形验证码
  getCaptchaImage() {
    return Instance.get("/captcha/image2?len=4", { baseURL });
  },
  postCaptchaImage(data) {
    if (data.ticket) {
      return Instance.post("/captcha/chuanglan", data, { baseURL });
      // return Instance.post("/captcha/tencent", data, { baseURL });
    }
    return Instance.post("/captcha/image", data, { baseURL });
  },
  getSmsCode(data) {
    return Instance.post(`/code/sms/v2?len=4&codeType=${data.codeType}`, data);
  },
  // 校验短信验证码
  verifySmsCode(data) {
    return Instance.post("/code/sms/verify", data);
  },
  handleLogin(data) {
    return Instance.post("/login", data);
  },
  // 获取个人信息
  getUserInfo() {
    return Instance.get("/user/resume");
  },
  // 获取最新职位
  getLatestJobs() {
    return Instance.get("/latest-jobs");
  },
  getWebConfig() {
    return Instance.get("/config");
  },
  getDict() {
    return Instance.get("/dict");
  },
  // 职位详情
  getJobDetail(id) {
    return Instance.get(`/jobs/${id}`);
  },
  // 上传照片
  uploadImg(data) {
    return Instance.post("/file/image", data);
  },
  // 修改个人信息
  changeResume(data) {
    return Instance.post("/resume", data);
  },
  //  个人中心获取拨号记录
  getCallLog(params) {
    return Instance.get("/call/log", { params });
  },
  // 获取零工拨号记录
  getServiceCallLog(params) {
    return Instance.get("/service/call/log", { params });
  },
  // 个人中心获取浏览记录
  getViewLog(params) {
    return Instance.get("/view/log", { params });
  },
  // 获取零工浏览记录
  getServiceViewLog(params) {
    return Instance.get("/service/view/log", { params });
  },
  // 获取职位列表
  getJobList(params) {
    params = trimString(params);
    return Instance.get("/jobs", { params });
  },
  // 获取零工分类
  getOddSubareaList() {
    return Instance.get("/service/subarea/list");
  },
  // 获取企业大分类
  getRecruitSubareaList() {
    return Instance.get("/info/subarea/list");
  },
  // 获取职位手机号
  getCompanyPhone(data) {
    return Instance.post("/call", data);
  },
  // 获取站点配置
  getWebConfigs() {
    return Instance.get("/web/config");
  },
  // 获取站点用户协议
  getAgreement() {
    return Instance.get("/web/agreement");
  },
  // 获取站点隐私政策
  getPrivacypolicy() {
    return Instance.get("/web/privacypolicy");
  },
  // 获取微信分享签名
  getSign(data) {
    return Instance.post("/wechat/sign-service", data, { baseURL });
  },
  // 获取可发布站点列表
  getAllowedPublishSiteList() {
    return Instance.get("/company/subsite", { baseURL });
  },
  // 获取零工服务列表
  getServiceList(params) {
    return Instance.get("/service/list", { params });
  },
  // 获取零工服务详情
  getServiceDetail(id) {
    return Instance.get(`/service/detail?id=${id}`);
  },
  // 发布零工服务
  addService(data) {
    return Instance.post("/service/create", data);
  },
  // 编辑零工服务
  updateService(id, data) {
    return Instance.post(`/service/update/${id}`, data);
  },
  // 实名认证
  realNameAuth(data) {
    return Instance.post("/user/real-name-auth", data);
  },
  // 获取零工电话
  getServiceCall(data) {
    return Instance.post("/service/call", data);
  },
  // 获取我的服务详情
  getMyService(params) {
    return Instance.get("/service/myService", { params });
  },
  // 删除服务
  deleteService(data) {
    return Instance.post("/service/delete", data);
  },
  // 企业入驻
  companyEnter(data) {
    return Instance.post("/company/enter", data);
  },
  // 人格入驻
  personEnter(data) {
    return Instance.post("/person/enter", data);
  },
  // 获取当前用户信息
  getCurrentInfo() {
    return Instance.get("/user");
  },
  getPersonInfo() {
    return Instance.get("/user/currentInfo");
  },
  getCompanyInfo() {
    return Instance.get("/company/current");
  },
  updateCompanyInfo(data) {
    return Instance.post("/company/update", data);
  },
  // 企业发布零工项目
  createCompanyProject(data) {
    return Instance.post("/company/info/create", data);
  },
  // 更新零工项目
  updateCompanyProject(data) {
    return Instance.post("/company/info/update", data);
  },
  // 企业发布的零工项目列表
  companyProList(params) {
    return Instance.get("/company/info/list", { params });
  },
  // 企业停止零工项目
  companyInfoStop(id, data) {
    return Instance.post(`/company/info/stop?id=${id}`, data);
  },
  // 企业重新发布零工项目
  companyRePublish(data) {
    return Instance.post("/company/info/rePublish", data);
  },
  // 零工项目详情
  getProjectDetail(id) {
    return Instance.get(`/company/info/detail?id=${id}`);
  },
  refreshPosition(data) {
    return Instance.post(`/company/info/refresh?id=${data.id}`, data);
  },
  getAllAddress(params) {
    return Instance.get(`/user/address`, { params });
  },
  createAddress(data) {
    return Instance.post("/user/address", data);
  },
  updateAddress(data) {
    return Instance.post("/user/edit-address", data);
  },
  changePhone(data) {
    return Instance.post("/userPhone", data);
  },
  serviceRefresh(id) {
    return Instance.get(`/service/refresh/${id}`);
  },
  serviceStop(id) {
    return Instance.get(`/service/stop/${id}`);
  },
  getServiceEditDetail(id) {
    return Instance.get(`/oddService/detail/${id}`);
  },
  getCaptchaConfig(params) {
    return Instance.get("/verify/captcha/config", { baseURL, params });
  },
  // 用户地址-删除地址
  deleteAddress(id) {
    return Instance.delete(`/user/address/${id}`);
  },
  // 招工/找活收费判断
  need_money(data) {
    return Instance.post("/authentication/center", data);
  },
  // 生成支付订单
  create_service_create_order(data) {
    return Instance.post("/service/create/buy", data);
  },
  create_service_update_order(data) {
    return Instance.post("/service/update/buy", data);
  },
  create_service_refresh_order(data) {
    return Instance.post("/service/refresh", data);
  },
  create_service_top_order(data) {
    return Instance.post("/service/top", data);
  },
  //支付
  getServiceOrderParams(data) {
    return Instance.post("/service/order", data, {
      headers : {
        'x-platform': 11,
      },
    });
  },

  // 生成支付订单
  create_info_create_order(data) {
    return Instance.post("/info/create/buy", data);
  },
  create_info_update_order(data) {
    return Instance.post("/info/update/buy", data);
  },
  create_info_refresh_order(data) {
    return Instance.post("/info/refresh/buy", data);
  },
  create_info_top_order(data) {
    return Instance.post("/info/refresh/top", data);
  },
  //支付
  getInfoOrderParams(data) {
    return Instance.post("/info/order", data, {
      headers : {
        'x-platform': 11,
      },
    })
  },
  getOrderPayLog(params) {
    return Instance.get("/pay/log", { params });
  },
  getInfoNum() {
    return Instance.get("/info/count");
  },
  getServiceNum() {
    return Instance.get("/service/count");
  },
  createInfoRepublishOrder(data) {
    return Instance.post("/info/rePublish/buy", data);
  },
  createServiceRepublishOrder(data) {
    return Instance.post("/service/rePublish", data);
  },
  cancelServiceTop(id) {
    return Instance.post("/service/cancel", {id});
  },
  cancelServiceInfo(id) {
    return Instance.post("/info/cancel", {id});
  },
  // out_trade_no,back_url,money
  weChatBuyBackUrl(data) {
    return Instance.post("../../v1/wechat/buyBackUrl", data);
  },
};
